/*
 * Candidates Details Page  Messages
 *
 * This contains all the text for the Candidates Details Page component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.CandidatesDetails';

export default defineMessages({
  ageLabel: { id: `${scope}.ageLabel`, defaultMessage: 'Age: {age}' },
  ratingLabel: {
    id: `${scope}.ratingLabel`,
    defaultMessage: 'Score (AVG): {score}',
  },
  certificatesLabel: {
    id: `${scope}.certificatesLabel`,
    defaultMessage: 'Certificates',
  },
  taxClassSaved: {
    id: `${scope}.taxClassSaved`,
    defaultMessage: 'Tax Class updated successfully',
  },
  certificateSaved: {
    id: `${scope}.certificateSaved`,
    defaultMessage: 'Certificate saved successfully',
  },
  certificateDeleted: {
    id: `${scope}.certificateDeleted`,
    defaultMessage: 'Certificate deleted successfully',
  },
  unavailabilityCancelled: {
    id: `${scope}.unavailabilityCancelled`,
    defaultMessage: 'Unavailability cancelled successfully',
  },
  attributesSaved: {
    id: `${scope}.attributesSaved`,
    defaultMessage: 'Attributes updated successfully',
  },
});
